const OrderStatus = {
  ACTIVE: true,
  INACTIVE: false
}

export default OrderStatus
